
    import '/mnt/src/components/Cascader/index.md?watch=parent';
    export const demoIndex = {
  ids: ["cascader-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Cascader/index.md?type=demo')
};